import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useCreateBin from '../../../hooks/bins/useCreateBin';
import {
  CreateBinDataType,
  createBinInitialValues,
  CreateBinSchema,
  ICreateBinRequest,
} from '../../../models/createBin/createBin.model';

// import { useAppSelector } from '../../../redux/store';

const CreateBinModal = () => {
  const { rackId } = useParams();
  // const binAction = useAppSelector((state) => state.bin);
  const { createBin, loading } = useCreateBin();

  const onSubmit = (values: CreateBinDataType, actions: any) => {
    const data: ICreateBinRequest = {
      ...values,
      binStatus: values.binStatus === 'Available' ? true : false,
      rackId: rackId!,
    };
    createBin(data);

    // if (resetInputFields) {
    actions.resetForm(createBinInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Bin'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={createBinInitialValues}
          schema={CreateBinSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="Bin Name"
            name="binName"
            type="text"
            placeholder="Enter Bin Name"
            className="full"
          />
          <TextInputField
            label="Bin Type"
            name="binType"
            type="text"
            placeholder="Enter Bin Type"
            className="full"
          />
          <SelectField label="Bin Status" name="binStatus">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Bin Status'}
            </option>
            <option>Available</option>
            <option>Not Available</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Bin
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateBinModal;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
  align-items: center;
`;
